import Paper from "@mui/material/Paper";
import type { SxProps, Theme } from "@mui/material/styles";
import type { ReactNode } from "react";
import CenteredSpinner from "../CenteredSpinner.tsx";

interface TableCardProps {
  /** A strip above the table: a `FilterBar` with search and filters. */
  toolbar?: ReactNode;
  /** Floats over the top of the rows: a `LiveUpdatesPill`. */
  notice?: ReactNode;
  /** Shows a spinner in place of the table (the toolbar stays). */
  loading?: boolean;
  /** Below the table, e.g. `UrlTablePagination` (which draws its own divider). */
  footer?: ReactNode;
  sx?: SxProps<Theme>;
  /** The `<ScrollTable>`. */
  children: ReactNode;
}

/** A list page's table: one filled box holding its toolbar, rows and pagination. */
export default function TableCard({ toolbar, notice, loading = false, footer, sx, children }: TableCardProps) {
  return (
    <Paper variant="outlined" sx={sx}>
      {toolbar}
      {!loading && notice}
      {loading ? <CenteredSpinner py={6} /> : children}
      {footer}
    </Paper>
  );
}
